var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.clipPlane,
          expression: "clipPlane"
        }
      ]
    },
    [
      _c("div", { staticClass: "sm-function-module-content" }, [
        _c("div", { staticClass: "sm-function-module-sub-section" }, [
          _c("label", { staticClass: "label-container" }, [
            _vm._v("第一点（经度，纬度，高程）:")
          ]),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.planeClipPoint1,
                expression: "planeClipPoint1"
              }
            ],
            staticClass: "middle-input",
            staticStyle: { width: "100%" },
            attrs: { disabled: "", type: "text", min: "0" },
            domProps: { value: _vm.planeClipPoint1 },
            on: {
              input: function($event) {
                if ($event.target.composing) return
                _vm.planeClipPoint1 = $event.target.value
              }
            }
          })
        ]),
        _c("div", { staticClass: "sm-function-module-sub-section" }, [
          _c("label", { staticClass: "label-container" }, [
            _vm._v("第二点（经度，纬度，高程）:")
          ]),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.planeClipPoint2,
                expression: "planeClipPoint2"
              }
            ],
            staticClass: "middle-input",
            staticStyle: { width: "100%" },
            attrs: { disabled: "", type: "text", min: "0" },
            domProps: { value: _vm.planeClipPoint2 },
            on: {
              input: function($event) {
                if ($event.target.composing) return
                _vm.planeClipPoint2 = $event.target.value
              }
            }
          })
        ]),
        _c("div", { staticClass: "sm-function-module-sub-section" }, [
          _c("label", { staticClass: "label-container" }, [
            _vm._v("第三点（经度，纬度，高程）:")
          ]),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.planeClipPoint3,
                expression: "planeClipPoint3"
              }
            ],
            staticClass: "middle-input",
            staticStyle: { width: "100%" },
            attrs: { disabled: "", type: "text", min: "0" },
            domProps: { value: _vm.planeClipPoint3 },
            on: {
              input: function($event) {
                if ($event.target.composing) return
                _vm.planeClipPoint3 = $event.target.value
              }
            }
          })
        ]),
        _c("div", { staticClass: "boxchild" }, [
          _c(
            "button",
            {
              staticClass: "tbtn tbn1",
              attrs: { type: "button" },
              on: { click: _vm.clipPlaneStart }
            },
            [_vm._v(" 裁剪 ")]
          ),
          _c(
            "button",
            {
              staticClass: "tbtn",
              attrs: { type: "button" },
              on: { click: _vm.clearClipPlane }
            },
            [_vm._v("清除")]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }